import VueCookies from "vue-cookies";
import {
  counttime
} from "../../assets/js/utils"
import {
  getToken,
  setToken,
  removeToken,
  isKeyToken,
  setcookie
} from "../../assets/js/auth"
import {
  loginapi,
  getInfoapi
} from "../../network/api/login";
//变量
const getDefaultState = () => {
  return {
    token: getToken(),
    userinfo: {},
    isLog: false,
    iswork: true //判断是否联网中平板
  }
}
const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SAVE_LOGININFO(state, logininfo) {
    let {
      token,
      expires_time
    } = logininfo; //获取token
    setToken(token, expires_time); //存入token到本地
  },
  SETUSERINFO: (state, data) => {
    state.userinfo = data; //用户基本信息
    if (state.userinfo) {
      state.isLog = true;
    }
  },
  LOGINOUT: (state) => {
    state.userinfo = {} //清除用户信息
    removeToken();
  },
  SETWORKSTATE(state, data) {
    state.iswork = data //设置当前平板网络状态
  }
}

const actions = {
  // user login
  login({
    commit
  }, loginForm) {
    const {
      username,
      password,
      imgcode
    } = loginForm
    return new Promise((resolve, reject) => {
      //login api的使用
      loginapi({
        username: username.trim(),
        password: password.trim(),
        imgcode: imgcode.trim(),
      }).then(response => {
        const {
          data
        } = response
        commit("SAVE_LOGININFO", data); //存入token 过期时间
        commit("SETUSERINFO", data.user_info); //存入用户基本信息
        setcookie('unitCategory',data.unit_category)
        // setToken(data.token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      // { token: state.token }
      getInfoapi(state.token).then(response => {
        const {
          data
        } = response
        if (!data) {
          return reject('验证失败，请重新登录')
        }
        commit('SETUSERINFO', response.data)
        resolve(response.data)
        // const { name, avatar } = data
        // commit('SET_NAME', name)
        // commit('SET_AVATAR', avatar)
        // resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     console.log(state.token)
  //     logout(state.token).then(() => {
  //       removeToken() // must remove  token  first
  //       resetRouter()
  //       commit('RESET_STATE')
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // remove token
  // resetToken({ commit }) {
  //   return new Promise(resolve => {
  //     removeToken()
  //     commit('RESET_STATE')
  //     resolve()
  //   })
  // }


}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js